import { SVGProps } from 'react';

const StyleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path d="M20.25 2.25H6.75A3.75 3.75 0 0 0 3 6v6.75A2.25 2.25 0 0 0 5.25 15h4.5l-.74 4.375A.789.789 0 0 0 9 19.5a3 3 0 0 0 6 0 .789.789 0 0 0-.01-.125L14.25 15h4.5A2.25 2.25 0 0 0 21 12.75V3a.75.75 0 0 0-.75-.75Zm-13.5 1.5h9.75V7.5a.75.75 0 1 0 1.5 0V3.75h1.5v6.75h-15V6a2.25 2.25 0 0 1 2.25-2.25Z" />
  </svg>
);

export default StyleIcon;
